<template>
    <PointSearchModal
        :visible.sync="localVisible"
        :keyword.sync="localKeyword"
        :loading="pointListLoading"
        :rows="filteredRows"
        :list-total-count="pointListTotalCount"
        :title="title"
        :subtitle="subtitle"
        :quick-filters="quickFilterOptions"
        :active-quick-filter="activeHintGroup"
        @search="$emit('search')"
        @quick-filter="onQuickFilterClick"
        @select="$emit('select', $event)"
        @close="onClose"
    />
</template>

<script>
import PointSearchModal from "@src/views/production-unit-config/components/PointSearchModal.vue";

export default {
    name: "EnIntPointSearchModal",
    components: { PointSearchModal },
    props: {
        visible: { type: Boolean, default: false },
        keyword: { type: String, default: "" },
        pointListApiState: {
            type: Object,
            default: () => ({ response: null, data: null, loading: false, error: "" }),
        },
        title: { type: String, required: true },
        subtitle: { type: String, default: "" },
        hintPtGroups: { type: Array, default: () => [] },
    },
    data() {
        return {
            activeHintGroup: "",
        };
    },
    computed: {
        localVisible: {
            get() {
                return this.visible;
            },
            set(v) {
                this.$emit("update:visible", v);
            },
        },
        localKeyword: {
            get() {
                return this.keyword;
            },
            set(v) {
                this.$emit("update:keyword", v);
            },
        },
        pointListLoading() {
            return Boolean(this.pointListApiState?.loading);
        },
        pointListRows() {
            return Array.isArray(this.pointListApiState?.data?.rows) ? this.pointListApiState.data.rows : [];
        },
        pointListTotalCount() {
            const totalCount = Number(this.pointListApiState?.data?.totalCount);
            return Number.isFinite(totalCount) ? totalCount : this.pointListRows.length;
        },
        quickFilterOptions() {
            if (!Array.isArray(this.hintPtGroups) || !this.hintPtGroups.length) return [];
            const seen = new Set();
            return this.hintPtGroups
                .map((groupCode) => String(groupCode ?? "").trim())
                .filter((groupCode) => {
                    const key = groupCode.toUpperCase();
                    if (!key || seen.has(key)) return false;
                    seen.add(key);
                    return true;
                })
                .map((groupCode) => ({ value: groupCode, label: groupCode }));
        },
        filteredRows() {
            const baseRows = this.pointListRows;
            const activeGroup = String(this.activeHintGroup || "")
                .trim()
                .toUpperCase();
            if (!activeGroup) return baseRows;
            return baseRows.filter((row) => {
                const rowGroup = String(row?.ptGroup || "")
                    .trim()
                    .toUpperCase();
                return rowGroup === activeGroup;
            });
        },
    },
    watch: {
        visible(val) {
            if (!val) this.resetQuickFilter();
        },
        hintPtGroups() {
            if (!this.activeHintGroup) return;
            const current = String(this.activeHintGroup).trim().toUpperCase();
            const exists = this.quickFilterOptions.some(
                (filter) => String(filter.value || "").trim().toUpperCase() === current,
            );
            if (!exists) this.activeHintGroup = "";
        },
    },
    methods: {
        onQuickFilterClick(value) {
            const clicked = String(value || "").trim();
            if (!clicked) {
                this.activeHintGroup = "";
                return;
            }
            const current = String(this.activeHintGroup || "")
                .trim()
                .toUpperCase();
            const next = clicked.toUpperCase();
            this.activeHintGroup = current === next ? "" : clicked;
        },
        onClose() {
            this.resetQuickFilter();
            this.$emit("close");
        },
        resetQuickFilter() {
            this.activeHintGroup = "";
        },
    },
};
</script>
